import {
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
} from "@ionic/react";
import { bulb, compass } from "ionicons/icons";
import { useContext } from "react";
import { Redirect, Route } from "react-router";
import { AppContext } from "./AppContext";
import projects from "../lib/projects";
import About from "../pages/About";
import Home from "../pages/Home";
import PrivacyPage from "../pages/Privacy";
import TermsPage from "../pages/Terms";
import { useTranslation } from "react-i18next";

const navigation = [
  {
    href: "/home",
    exact: true,
    Page: Home,
    tab: {
      label: "Home",
      icon: compass,
      tab: "home",
    },
  },
  {
    href: "/about",
    exact: true,
    Page: About,
    tab: {
      label: "about",
      icon: bulb,
      tab: "about",
    },
  },
  {
    href: "/privacy",
    exact: true,
    Page: PrivacyPage,
  },
  {
    href: "/terms",
    exact: true,
    Page: TermsPage,
  },
  ...projects,
];

interface props {}

const Tabs: React.FC<props> = () => {
  const {
    tabBar: { tabBarHidden },
  } = useContext(AppContext);

  const { t } = useTranslation();
  return (
    <IonTabs>
      <IonRouterOutlet>
        {navigation.map(({ href, exact, Page }) => (
          <Route
            key={`Route.${href}`}
            exact={exact}
            path={href}
            component={Page}
          />
        ))}
        <Route exact path="/">
          <Redirect to="/home" />
        </Route>
      </IonRouterOutlet>
      <IonTabBar
        slot="bottom"
        className={`${
          tabBarHidden ? "opacity-0 pointer-events-none max-h-0" : "opacity-100"
        } transition-opacity`}
      >
        <IonTabButton tab={"home"} href={"/home"}>
          <IonIcon icon={compass} />
          <IonLabel>{t(`Home`)}</IonLabel>
        </IonTabButton>
        <IonTabButton tab={"about"} href={"/about"}>
          <IonIcon icon={bulb} />
          <IonLabel>{t(`About`)}</IonLabel>
        </IonTabButton>
      </IonTabBar>
    </IonTabs>
  );
};

export default Tabs;
